module.exports = __webpack_public_path__ + "img/header.c810b971.png";